import React from 'react'
import PubSub from 'pubsub-js'

import ActionModal from './ActionBar/ActionModal'

export class ItemDetailActions extends React.PureComponent {
  state = {
    modalCollection: null,
  }

  componentWillMount () {
    this.subscriptions = PubSub.subscribe('ITEM.ADD_TO', this.onItemAction.bind(this))
  }

  componentWillUnmount () {
    PubSub.unsubscribe(this.subscription)
  }

  onItemAction (msg, data) {
    return this.setState({ modalCollection: msg.split('.').pop() })
  }

  closeModal () {
    this.setState({ modalCollection: null })
  }

  render () {
    return (
      <ActionModal
        modalOpen={this.state.modalCollection !== null}
        items={[this.props.item]}
        close={() => this.closeModal()}
        singleCollection={this.state.modalCollection}
        {...this.props}
      />
    )
  }
}

export default ItemDetailActions



// WEBPACK FOOTER //
// ./app/javascript/components/ItemDetailActions.js